import { cva } from 'class-variance-authority';

export const cardVariants = cva(['rounded-lg', 'transition-all', 'duration-200'], {
  variants: {
    variant: {
      default: ['bg-white', 'dark:bg-slate-800', 'shadow-sm', 'dark:shadow-slate-900/20'],
      bordered: [
        'bg-white',
        'dark:bg-slate-800',
        'border',
        'border-gray-200',
        'dark:border-slate-700',
      ],
      elevated: ['bg-white', 'dark:bg-slate-800', 'shadow-lg', 'dark:shadow-slate-900/20'],
      outlined: ['bg-transparent', 'border-2', 'border-gray-300', 'dark:border-slate-600'],
    },
    padding: {
      none: ['p-0'],
      sm: ['p-4'],
      md: ['p-6'],
      lg: ['p-8'],
    },
    hoverable: {
      true: ['hover:shadow-md', 'hover:-translate-y-0.5'],
      false: [],
    },
    clickable: {
      true: ['cursor-pointer', 'hover:shadow-md'],
      false: [],
    },
  },
  defaultVariants: {
    variant: 'default',
    padding: 'md',
    hoverable: false,
    clickable: false,
  },
});
